import {
  requestRightsData,
  RightsDataSearchParams,
} from '@disco/api/rights-data'
import type { RightsData } from '@disco/types/types/rights-data'

import { api } from './index'

export const rightsDataApi = api
  .enhanceEndpoints({ addTagTypes: ['RightsData'] })
  .injectEndpoints({
    endpoints: build => ({
      searchRightsData: build.query<RightsData, RightsDataSearchParams>({
        queryFn: async params => {
          try {
            const data = await requestRightsData(params)
            return { data }
          } catch (error) {
            const status =
              error != null &&
              typeof error === 'object' &&
              'status' in error &&
              typeof error.status === 'number'
                ? error.status
                : ('FETCH_ERROR' as const)
            return { error: { status, data: error } }
          }
        },
        providesTags: ['RightsData'],
      }),
    }),
  })

export const { useSearchRightsDataQuery } = rightsDataApi
